import { AnyIndustryEntityVersion, FirestoreEntity, Industry, Mapper } from '@uploadcam/common';
import { CollectionReference, getDocs, query } from 'firebase/firestore';

export class GetIndustriesInteractor {
  constructor(
    private readonly collection: CollectionReference<AnyIndustryEntityVersion>,
    private readonly mapper: Mapper<FirestoreEntity<AnyIndustryEntityVersion>, Industry>,
  ) {}

  public async execute(): Promise<Industry[]> {
    const result = await getDocs(query(this.collection));

    return result.docs.map((doc) => this.mapper.map(FirestoreEntity.from(doc)));
  }
}
